function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -952.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11 968.36c-3.2893 0-6 2.7106-6 6v56c0 3.2893 2.7107 6 6 6h78c3.2894 0 6-2.7107 6-6v-56c0-3.2894-2.7106-6-6-6zm0 4h78c1.1425 0 2 0.85746 2 2v41.844l-16.75-13.406c-0.66198-0.5305-1.6733-0.5704-2.375-0.094l-14.781 10.156-19.844-16.062c-0.41435-0.33855-0.96861-0.50021-1.5-0.4375-0.31336 0.0432-0.61601 0.16213-0.875 0.34375l-25.875 17.844v-40.188c0-1.1425 0.85746-2 2-2zm46 10c-4.3946 0-8 3.6054-8 8s3.6054 8 8 8c4.3946 0 8-3.6054 8-8s-3.6054-8-8-8zm0 4c2.2328 0 4 1.7672 4 4s-1.7672 4-4 4c-2.2328 0-4-1.7672-4-4s1.7672-4 4-4zm-21.094 14.469 19.844 16.062c0.66198 0.5306 1.6733 0.5705 2.375 0.094l14.75-10.156 18.125 14.5v9.0312c0 1.1426-0.85746 2-2 2h-78c-1.1425 0-2-0.8574-2-2v-10.969l26.906-18.562z",
    color: "#000000",
    overflow: "visible",
    style: {
      blockProgression: "tb",
      textIndent: 0,
      textTransform: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.20ad2d9b.svg";
export { ForwardRef as ReactComponent };